<template>
  <!--
    O PRÊMIO das missões do dia, com o tier em estrelas-do-mar — sprite, nunca caractere (UI-10).

    O tier é o que explica o tamanho do dia: é ele que decide quantas missões há (3 a 5) e quanto
    cada uma pede. Sem o prêmio à vista, o quadro era uma lista de tarefas sem motivo — o autor, em
    11/09/2026: "ter só pra ter não faz sentido". Mora aqui porque aparece em dois lugares (o quadro
    e a tábua do Cais), e duas versões da mesma coisa foi exatamente o defeito da linha de missão.
  -->
  <div class="premio" :class="{ 'premio--compacto': compacto }">
    <p class="premio__rotulo">
      {{ $t('dailyMissions.reward') }}
      <span class="premio__estrelas" :aria-label="$t('dailyMissions.tierDe', { n: premio.tier })">
        <FishIcon v-for="n in premio.tier" :key="n" nome="star" tamanho="miudo" />
      </span>
    </p>
    <p class="premio__valor">
      <FishIcon :nome="premio.type === 'paralleliums' ? 'gem' : 'coins'" tamanho="pequeno" />
      <strong class="t-numero">+{{ premio.amount.toLocaleString('pt-BR') }}</strong>
      {{ $t(`inventory.${premio.type}`) }}
    </p>
  </div>
</template>

<script>
import { FishIcon } from '@/shared/ui';

export default {
  name: 'PremioDasMissoes',
  components: { FishIcon },
  props: {
    /** O `rewardFormatted` da store: `{ type: 'gold' | 'paralleliums', amount, tier }`. */
    premio: { type: Object, required: true },
    /** Uma linha só, para a tábua do Cais. */
    compacto: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.premio {
  display: flex;
  flex-direction: column;
  gap: var(--e-1);
  text-align: left;
}

.premio--compacto {
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--e-1) var(--e-3);
}

.premio__rotulo {
  margin: 0;
  font-family: var(--fonte-display);
  font-size: var(--f-1);
  color: var(--tinta-fraca);
  display: flex;
  align-items: center;
  gap: var(--e-2);
}

.premio__estrelas {
  display: inline-flex;
  gap: 2px;
}

.premio__valor {
  margin: 0;
  display: flex;
  align-items: center;
  gap: var(--e-1);
  font-size: var(--f-2);
  color: var(--tinta);
}

.premio__valor strong {
  color: var(--latao);
  font-size: var(--f-3);
}
</style>
